module.exports = __webpack_public_path__ + "9ac580a3aa0b8b72c2f3b74fb20114ef.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/wave-right-30.png
// module id = 2711
// module chunks = 0